// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@steiner/App/SharedStyles/CartLineSharedStyles";
import { requisitionsProductListLineStyles } from "@steiner/Overrides/Widgets/Requisitions/RequisitionsProductListLine";
import { color, mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

requisitionsProductListLineStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

requisitionsProductListLineStyles.productPriceStyles = {
    ...cartLineSharedStyles.productPrice,
};

requisitionsProductListLineStyles.subtotalHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

requisitionsProductListLineStyles.productPartNumbersStyles = {
    ...cartLineSharedStyles.productPartNumbers,
};

requisitionsProductListLineStyles.productImageStyles = {
    ...mergeWithCss(cartLineSharedStyles.productImage, {
        linkWrappingImage: {
            css: css`
                width: 120px;
                height: 120px;
            `,
        },
    }),
};

requisitionsProductListLineStyles.requisitionLinesAccordion = {
    mergeCss: true,
    css: css`
        margin-top: 10px;
    `,
};

requisitionsProductListLineStyles.GridContainer = {
    notes: {
        css: css`
            grid-column: 1 / 8;
            grid-row: 5 / 6;
            margin-top: 10px;
            padding: 0;

            p {
                text-align: left;
            }
        `,
    },
    qty: {
        css: css`
            display: flex;
            flex-direction: column;

            label {
                margin-bottom: 4px;
            }
        `,
    },
    container: {
        css: css`
            grid-template-columns: 160px minmax(0, 380px) minmax(0, 180px) minmax(0, 124px) minmax(0, 180px) 1fr;
            position: relative;
            padding: 12px 0 12px 12px;
            margin-bottom: 12px;
            &:last-child {
                border-bottom: 1px solid ${color("common.border")};
            }
            grid-column-gap: 12px;
        `,
    },
    image: {
        css: css`
            display: flex;
            flex-direction: row-reverse;
            align-items: flex-start;
            gap: 24px;
        `,
    },
};

requisitionsProductListLineStyles.selectedCheckbox = {};

requisitionsProductListLineStyles.linesHeader = {
    wrapper: {
        css: css`
            grid-template-columns: 160px minmax(0, 380px) minmax(0, 180px) minmax(0, 124px) minmax(0, 180px) minmax(
                    0,
                    24px
                );
            grid-column-gap: 12px;
        `,
    },
};

requisitionsProductListLineStyles.qtyOrderedField = {
    labelText: {
        css: css`
            display: none;
            ${xScreen("lte", "md")} {
                display: block;
            }
        `,
    },
};
